import React from 'react';
import Lottie from 'lottie-react-web';
import animation from './data.json';

const SwiperLottie = () => {
  return (
    <div style={{transform: 'translate(1%, -45%)'}}>
      <Lottie options={{animationData: animation}}/>
    </div>
  );
};

export default SwiperLottie;


// WEBPACK FOOTER //
// ./src/app/intro/components/SwipeLottie/SwipeLottie.js